export const captureThumbnailFromVideo = ({
  // videoRef,
  videoUrl,
}: {
  // videoRef: React.MutableRefObject<any>;
  videoUrl: string;
}) => {
  // const video = videoRef.current;
  // if (video) {
  //   const canvas = document.createElement('canvas');
  //   canvas.width = video.videoWidth;
  //   canvas.height = video.videoHeight;
  //   const ctx = canvas.getContext('2d');
  //   if (!ctx) {
  //     return undefined;
  //   }

  //   ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  //   return canvas.toDataURL('image/png'); // Generate a data URL for the thumbnail
  // }
  return videoUrl;
};

export const getGoogleDriveVideoId = ({ videoUrl }: { videoUrl: string }) => {
  const base = 'https://drive.google.com/file/d/';
  if (!videoUrl || videoUrl.indexOf(base) < 0) {
    return undefined;
  }
  const id = videoUrl.split(base)[1].split('/')[0];
  return id;
};

export const getGoogleDriveVideoThumbnail = ({ videoId }: { videoId: string }) => {
  if (!videoId) {
    return;
  }
  // Generate the thumbnail URL
  const thumbnailUrl = `https://drive.google.com/thumbnail?id=${videoId}`;
  return thumbnailUrl;
};

export const getGoogleDriveVideoSrc = ({ videoId }: { videoId: string }) => {
  return `https://drive.google.com/file/d/${videoId}/preview`;
};


/** Standard YouTube video IDs are 11 chars; allow same charset for forward compatibility */
const YOUTUBE_ID_PATTERN = '([A-Za-z0-9_-]{11})';

export const getYouTubeVideoId = ({ videoUrl }: { videoUrl: string }) => {
  if (!videoUrl || typeof videoUrl !== 'string') {
    return undefined;
  }
  const url = videoUrl.trim();
  const youtuBe = url.match(new RegExp(`youtu\\.be/${YOUTUBE_ID_PATTERN}`));
  if (youtuBe?.[1]) {
    return youtuBe[1];
  }
  const embed = url.match(
    new RegExp(`youtube\\.com/embed/${YOUTUBE_ID_PATTERN}`)
  );
  if (embed?.[1]) {
    return embed[1];
  }
  const watch = url.match(new RegExp(`[?&]v=${YOUTUBE_ID_PATTERN}`));
  if (watch?.[1]) {
    return watch[1];
  }
  return undefined;
};

export const getYouTubeVideoThumbnail = ({ videoId }: { videoId: string }) => {
  if (!videoId) {
    return undefined;
  }
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  return thumbnailUrl;
};

export const getYouTubeVideoSrc = ({ videoId }: { videoId: string }) => {
  return `https://www.youtube.com/embed/${videoId}`;
};
